<template>
  <div>
    <!-- Table Container Card -->
    <modal-edit-issue
      :issue-data="selectedIssue"
      :supplier-options="supplierOptions"
      @refetch-data="refetchData"
      @modal-hidden="handleModalHidden"
    />

    <!--  <b-card no-body>
      <b-card-header class="pb-50">
        <h5>過濾器</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>供應商</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="supplierFilter"
              :options="supplierOptions"
              label="name"
              class="w-100"
              :reduce="(val) => val.value"
            />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card> -->

    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="搜尋..."
              />
              <b-button
                variant="primary"
                v-if="ability.can('create', 'stock-issues')"
                @click="isAddNewIssueSidebarActive = true"
                :to="{ name: 'stock-issue-create' }"
              >
                <span class="text-nowrap">出倉</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refIssueListTable"
        class="position-relative"
        :items="fetchIssues"
        responsive
        stacked="md"
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!--Column: Position -->
        <!--         <template #cell(position_id)="data">
          <div v-if="data.item.position">{{ data.item.position.position }}</div>
        </template> -->

        <template #cell(issue_products)="data">
          <template v-if="data.item.items.length > 0"
            ><b-button
              v-model="data.detailsShowing"
              variant="secondary-outline"
              pill
              size="sm"
              @click="data.toggleDetails"
              style="text-decoration: underline dotted green"
              >{{ data.detailsShowing ? "隱藏" : "顯示" }}</b-button
            >
          </template>
          <template v-else> 沒有產品</template>
        </template>

        <template #row-details="data">
          <b-card>
            <b-row class="mb-2">
              <b-col style="background-color: #f2f2f2">
                <div
                  v-for="(product, index) in data.item.items"
                  :key="'issue_' + data.item.id + '_product_' + index"
                  style="padding: 10px; margin: 5px"
                >
                  <div>
                    <div />
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <b-col md="4">
                        <b-form-group
                          class="required"
                          label="產品名稱"
                          label-for="name"
                        >
                          <b-form-input
                            id="name"
                            :value="product.product && product.product.name"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="2">
                        <b-form-group
                          class="required"
                          label="數量"
                          label-for="quantity"
                        >
                          <b-form-input
                            id="quantity"
                            :value="product.quantity"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="2">
                        <b-form-group
                          class="required"
                          label="備註"
                          label-for="remark"
                        >
                          <b-form-input
                            id="remark"
                            :value="product.remark"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-button
              size="sm"
              variant="outline-secondary"
              @click="data.toggleDetails"
            >
              Hide
            </b-button>
          </b-card>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <!--        <b-dropdown-item :to="{ name: 'issues-view', params: { id: data.item.id } }">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">詳情</span>
            </b-dropdown-item> -->

            <b-dropdown-item
              v-if="
                ability.can('update', 'stock-issues') &&
                data.item.deleted_at == null
              "
              @click="handleEdit(data.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">修改</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="
                ability.can('delete', 'stock-issues') &&
                data.item.deleted_at == null
              "
              @click="confirmDelete(data.item.id)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">刪除</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalIssues"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BCardHeader,
  BCardBody,
  BFormGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import useIssuesList from "./useIssuesList";
import issueStoreModule from "../issueStoreModule";
import { getNextCycleEndDate, dateDifferent } from "@/libs/helper";
import ModalEditIssue from "./ModalEditIssue.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormGroup,
    ModalEditIssue,
  },
  methods: {
    handleEdit(issue) {
      this.selectedIssue = { ...issue };
      this.$bvModal.show("modal-edit-issue");
    },
    handleModalHidden() {
      this.selectedIssue = {};
    },
    confirmDelete(id) {
      this.$swal({
        title: "確認刪除?",
        text: "",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("app-issue/deleteIssue", { id: id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    confirmRestore(id) {
      this.$swal({
        title: "確認刪恢復?",
        showCancelButton: true,
        confirmButtonText: "恢復",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(`app-issue/restoreIssue`, id)
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    triggerResetPasswordModal(item) {
      console.log("triggerResetPasswordModal", item);
      this.issueInfo.id = item.id;
      this.issueInfo.name = item.name;
      this.issueInfo.password = "";
      this.issueInfo.password_confirmation = "";
      this.$bvModal.show("modal-reset-issue-password");
    },
  },
  data() {
    return {
      issueInfo: { id: 0, password: "", password_confirmation: "" },
      getNextCycleEndDate,
      dateDifferent,
      selectedIssue: {},
    };
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "app-issue";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, issueStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const isAddNewIssueSidebarActive = ref(false);

    const statusOptions = [
      { label: "啟用", value: 1 },
      { label: "禁用", value: 0 },
      { label: "全部", value: null },
    ];

    const deleteOptions = ref([
      {
        label: "已刪除",
        value: 1,
      },
    ]);

    const {
      fetchIssues,
      tableColumns,
      perPage,
      currentPage,
      totalIssues,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refIssueListTable,
      refetchData,
      // Extra Filters
      supplierFilter,
      supplierOptions,
      ability,
    } = useIssuesList();

    return {
      // Sidebar
      isAddNewIssueSidebarActive,

      fetchIssues,
      tableColumns,
      perPage,
      currentPage,
      totalIssues,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refIssueListTable,
      refetchData,
      ability,

      // Filter
      avatarText,

      // Extra Filters
      supplierFilter,

      supplierOptions,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
